module.exports = "/_next/static/images/QuizHub-7ef1c35b635c9eabbedeac1c8bbe1464.svg";